import _ from 'lodash';
import React from 'react';
import RaisedButton from 'material-ui/RaisedButton';
import update from 'immutability-helper';
import Delete  from '../Buttons/Delete';
import Field from 'components/Form/Field';

export default class PositionEditor extends React.Component {

    constructor(props) {
        super(props);
        var val = this.props.value ? this.props.value : {};
        this.state = {
            value: val,
        };
    }
    
    componentWillReceiveProps = (e) => {
        this.setState({
            value: e.value,
        });
    }

    handleDeletePosition = (id) => {

        const next = update(this.state, { 
            value: { 
                [id]: {$set:undefined}}
        });
        delete next.value[id];

        this.setState(next);
    }

    handleValueChange = (id, field) => {
        const next = update(this.state, { 
            value: { 
                [id]:{$merge: {value: field.state.value}}
            }
        });
        this.setState(next);
    }
    handleDeliveryDateChange = (id, field) => {
        const next = update(this.state, { 
            value: { 
                [id]:{$merge: {deliveryDate: field.state.value}}
            }
        });
        this.setState(next);
    }
    handleMaterialDateChange = (id, field) => {
        const next = update(this.state, { 
            value: { 
                [id]:{$merge: {materialDate: field.state.value}}
            }
        });
        this.setState(next);
    }

    
    handleAddPosition = () => {

        var id = "id"+(new Date().valueOf());
        var newposition = { value: { [id]: {value:''}}};
        var next = _.merge({}, this.state, newposition);
        this.setState(next );
        
    }
    
    renderRow = () => {
        return _.map(this.state.value, (position, key) => {
            return (
                <div key={key} className="positioneditor__position">
                    <Field handleChange={this.handleValueChange.bind(this,key)} value={position.value} floatingLabelText="Placering"/>
                    <span><Delete handleClick={this.handleDeletePosition.bind(this, key)} /></span>
                </div>
            );
        });
    }

    render() {
        return (
            <div className="_">
                <RaisedButton primary={true} label="Lägg till placeringsval" onTouchTap={this.handleAddPosition} />
                {this.renderRow()}
            </div>
        );
    }
}





// WEBPACK FOOTER //
// ./src/components/Form/PositionEditor.jsx